var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFecharSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "30px",
    viewBox: "0 0 29 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Limpar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Mobile_Home_Pesquisa_avan\\xE7ada",
    transform: "translate(-438.000000, -1095.000000)",
    fill: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "pesquisa_avan\\xE7ada",
    transform: "translate(52.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(2.000000, 545.800000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.873772,76 C410.305761,76 409.768247,75.7751052 409.364159,75.3748686 L398.499523,64.5113039 L387.634888,75.3748686 C387.2308,75.7751052 386.697098,76 386.129087,76 C385.561077,76 385.023563,75.7751052 384.623287,75.3748686 C383.792238,74.5439012 383.792238,73.1945321 384.623287,72.3635647 L395.487923,61.4961882 L384.623287,50.6326236 C383.792238,49.8054679 383.792238,48.4522871 384.623287,47.6251314 C385.023563,47.2210831 385.561077,47 386.129087,47 C386.697098,47 387.2308,47.2210831 387.634888,47.6213197 L398.499523,58.4886961 L409.364159,47.6213197 C409.768247,47.2210831 410.305761,47 410.873772,47 C411.441783,47 411.975484,47.2210831 412.379572,47.6213197 C413.206809,48.4522871 413.206809,49.8054679 412.379572,50.6326236 L401.511124,61.4961882 L412.379572,72.3635647 C413.206809,73.1945321 413.206809,74.5439012 412.379572,75.3748686 C411.975484,75.7751052 411.441783,76 410.873772,76",
    id: "Fill-2332-Copy"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFecharSelect);
export default __webpack_public_path__ + "static/media/fechar-select.4589ea5f2f717d51131b807ab1e9423c.svg";
export { ForwardRef as ReactComponent };